import SkillsEditing from './skills-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class SkillsUI extends Plugin {
    init() { }
}
export default class Skills extends Plugin {
    static get requires() {
        return [SkillsEditing, SkillsUI];
    }
}
